var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading && _vm.advert)?_c('a',{attrs:{"href":`/click/${_vm.advert.id}`,"target":"_blank"}},[_c('img',{staticClass:"banner img-fluid",attrs:{"src":_vm.advert.image,"alt":"Banner"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }